import { useContext } from "react";
import { useRouteLoaderData } from "react-router-dom";

import { Button } from "@icg360/design-system";

import { GlobalContext } from "components/root/global-provider";
import { useFlags } from "utils";

import styles from "./admin-tools.module.scss";

export const AdminTools = () => {
  const { adminTools } = useFlags();
  const { setShowPolicyNotes } = useContext(GlobalContext);

  const privateLoaderData = useRouteLoaderData("private");

  if (!adminTools) {
    return null;
  }

  return (
    <div className={styles.adminToolsWrapper}>
      {privateLoaderData ? (
        <Button
          icon="Notes"
          appearance="tertiary"
          onPress={() => setShowPolicyNotes((curVal) => !curVal)}
        />
      ) : null}
    </div>
  );
};
